import request2 from '@/utils/request2'

// 获取招标公告/采购信息明细
export const getZhaoBiaDetail = (data) => {
    return request2.post('ZhaoTouBiao/WebsitePublic.ashx?method=getZhaoBiaDetail', data)
}

// 获取资格预审公告明细
export const getZiGeYuShenDetail = (data) => {
    return request2.post('ZhaoTouBiao/WebsitePublic.ashx?method=getZiGeYuShenDetail', data)
}

// 获取中标候选人公示明细
export const getHouXuanRenGongShiDetail = (data) => {
    return request2.post('ZhaoTouBiao/WebsitePublic.ashx?method=getHouXuanRenGongShiDetail', data)
}

// 获取中标结果公示/采购结果明细
export const getZhongBiaoJieGuoDetail = (data) => {
    return request2.post('ZhaoTouBiao/WebsitePublic.ashx?method=getZhongBiaoJieGuoDetail', data)
}

// 获取更正公告（建设工程/政府采购）明细
export const getGengZhengGongGaoDetail = (data) => {
    return request2.post('ZhaoTouBiao/WebsitePublic.ashx?method=getGengZhengGongGaoDetail', data)
}

// 获取附件
export const getFilesApi = (data)=>{
    return request2.post('ZhaoTouBiao/WebsitePublic.ashx', data,{headers:{'Content-Type': 'application/x-www-form-urlencoded'}})
}